import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPagedResult } from 'src/app/shared/models/pagedResult';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';
import { ProfileHistory } from '../models/profileHistory';

@Injectable()
export class HistoryService extends BaseService {
  private basePath = 'history';

  constructor() {
    super();
  }

  profileHistory(
    pageIndex: number,
    pageSize: number,
    personId: string
  ): Observable<IPagedResult<ProfileHistory>> {
    return this.get<IPagedResult<ProfileHistory>>(
      this.basePath,
      {
        params: {
          pageIndex: String(pageIndex),
          pageSize: String(pageSize),
          personId: personId.trim()
        }
      },
      ApiVersions.v1_0
    );
  }

  profileFieldHistory(
    pageIndex: number,
    pageSize: number,
    personId: string,
    teamId: string,
    attributeName: string,
    entityType: string
  ): Observable<IPagedResult<ProfileHistory>> {
    const params: Record<string, string> = {
      pageIndex: String(pageIndex),
      pageSize: String(pageSize),
      attributeName,
      entityType
    };
    if (personId?.trim()) {
      params['personId'] = personId.trim();
    }
    if (teamId?.trim()) {
      params['teamId'] = teamId.trim();
    }

    return this.get<IPagedResult<ProfileHistory>>(
      this.basePath + '/field-history',
      { params },
      ApiVersions.v1_0
    );
  }
}
